import { ApolloClient, gql } from 'apollo-boost';
import { SuccessResponse } from '../NewReport/api';
import { allUsers } from 'shared/apollo/queries';
import { ReportVisibility } from 'shared/auth/hooks/useUserActions';
import { ContributionEligibility } from '../ContributionEligibility/ContributionEligibilitySelector';

const newProgramMutation = gql`
  mutation program(
    $name: String!
    $visibility: String!
    $status: String!
    $managerId: Int!
    $logoFileId: Int
    $level1Note: String
    $contributionEligibility: String
  ) {
    newProgram(
      name: $name
      visibility: $visibility
      status: $status
      managerId: $managerId
      logoFileId: $logoFileId
      level1Note: $level1Note
      contributionEligibility: $contributionEligibility
    ) {
      success
      id
    }
  }
`;

export interface NPOUser {
  email: string;
  firstName: string;
  lastName: string;
  userId: number;
  dbId: number;
  title: string;
  phone: string;
  enabled: boolean;
}

export const getAllNPOUsers = (client: ApolloClient<object>) => {
  return client.query<{ allUsers: NPOUser[] }>({
    query: allUsers,
    fetchPolicy: 'network-only',
  });
};

export interface NewProgram {
  logoFileId: null;
  managerId: number;
  name: string;
  status: 'active';
  visibility: ReportVisibility;
  level1Note?: string;
  contributionEligibility?: ContributionEligibility;
}

export const createProgram = (
  client: ApolloClient<object>,
  program: NewProgram,
) => {
  return client.mutate<SuccessResponse<'newProgram'>>({
    mutation: newProgramMutation,
    variables: program,
    fetchPolicy: 'no-cache',
  });
};
